(function (recruitment, $) {
    /* Initialize tinymce */
    recruitment.InitTinyMCE = function () {
        var settings = {
            selector: '#Settings_Email',
            language: 'nl',
            branding: false,
            contextmenu: false,
            menubar: false,
            statusbar: false,
            plugins: 'lists',
            toolbar: 'bold italic underline | numlist bullist | removeformat',
            lists_indent_on_tab: false,
            entity_encoding: 'raw'
        };
        tinymce.init(settings);
        settings.selector = '#Settings_Signature';
        tinymce.init(settings);
    }

    /**
     * Renew employee
     * @param {any} subscriptionKey Subscription environment key
     * @param {any} key Employee key
     */
    recruitment.RenewEmployee = (subscriptionKey, key) => {
        $.get({
            url: '/Recruitment/RenewEmployee',
            data: { 'subscriptionKey': subscriptionKey, 'key': key },
            complete: function (result) {
                if (result.responseJSON.success) {
                    globalCore.refreshTable(result.responseJSON);
                }
            }
        });
    }

    recruitment.InitRecruitmentAttachmentsGrid = function (subscriptionKey) {
        $("#recruitmentAttachmentsGrid").DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/Recruitment/SearchAttachments?subscriptionKey=${subscriptionKey}`
            },
            columns: [
                { data: "type", name: "Type", title: "Soort", orderable: true, searchable: false },
                { data: "dossierItemTypeId", name: "DossierItemTypeId", title: "Dossieritem type", orderable: true, searchable: false },
                { data: "required", name: "Required", title: "Verplicht", orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 1,
                    className: 'text-center'
                },
                {
                    targets: 2,
                    className: 'text-center',
                    render: function (data, type, full, meta) {
                        return full.required === true ? "Ja" : "Nee";
                    }
                },
                {
                    targets: -1,
                    className: 'text-end text-nowrap',
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let buttons = `<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-outline-primary fas fa-edit" title="Wijzigen" href="/Recruitment/EditAttachment?subscriptionKey=${subscriptionKey}&key=${full.key}"></a>`;
                        if (!full.mandatory) {
                            buttons += `<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/Recruitment/DeleteAttachment?subscriptionKey=${subscriptionKey}&key=${full.key}"></a>`;
                        }
                        return buttons;
                    }
                }
            ]
        }));
    }

    recruitment.InitToggles = function (defaultValue) {
        var change = function (value) {
            var test = `${value}`;
            if (test == 'True' || test == 'true') {
                $("[data-appendable-selected=True]").show();
                $("[data-appendable-selected=False]").hide();
            }
            else {
                $("[data-appendable-selected=True]").hide();
                $("[data-appendable-selected=False]").show();
            }
        };

        $("[data-recruitment-data-appendable]").on("change", function () {
            change(this.value);
        });
        change(defaultValue);
    }

    recruitment.InitRecruitmentEmployeesGrid = function (subscriptionKey) {
        $("#recruitmentEmployeesGrid").DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/Recruitment/SearchEmployees?subscriptionKey=${subscriptionKey}`
            },
            columns: [
                { data: "created", name: "Created", title: "Aangemaakt op", orderable: true, searchable: false },
                { title: "Naam", orderable: false, searchable: false },
                { data: "email", name: "Email", title: "E-mail", orderable: true, searchable: false },
                { data: "processState", name: "ProcessState", title: "Status", orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 0,
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(full.created, "DD-MM-yyyy HH:mm");
                    }
                },
                {
                    targets: 1,
                    render: function (data, type, full, meta) {
                        return `${full.firstName} ${full.lastName}`;
                    }
                },
                {
                    targets: -1,
                    className: 'text-end text-nowrap',
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `
                            <a class="btn btn-outline-primary fas fa-refresh" href="/Recruitment/RenewEmployee?subscriptionKey=${subscriptionKey}&key=${full.key}" data-ajax="true" data-ajax-success="globalCore.refreshTable" title="Geldigheid resetten en e-mail opnieuw versturen."></a>
                            <a class="btn btn-outline-primary fas fa-trash" title="Medewerker verwijderen uit de Recruitment database." href="/Recruitment/DeleteEmployee?subscriptionKey=${subscriptionKey}&key=${full.key}" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>`;
                    }
                }
            ]
        }));
    }

}(window.recruitment = window.recruitment || {}, jQuery));
